/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import {
	ActionIcon,
	Flex,
	NumberInput as NativeNumberInput,
	NumberInputHandlers,
	NumberInputProps,
	Stack,
} from '@mantine/core';
import { Text } from '../Text';
// Styles
import {
	IconChevronDown,
	IconChevronUp,
} from '@tabler/icons-react';
import { useRef } from 'react';
import classes from './NumberInput.module.css';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

export type TNumberInputProps = Omit<
	NumberInputProps,
	'prefix' | 'suffix'
> & {
	unit?: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export const NumberInput = ({
	unit,
	...rest
}: TNumberInputProps) => {
	const handlersRef = useRef<NumberInputHandlers>(null);
	const showRightSection = !rest.hideControls && unit;
	return (
		<NativeNumberInput
			handlersRef={handlersRef}
			classNames={classes}
			rightSection={
				showRightSection ? (
					<Flex gap={'5px'} align="center" pr={15}>
						<Text c={'#9BA6B7'} variant="body2">
							{unit}
						</Text>
						<Stack gap={0}>
							<ActionIcon
								onClick={() =>
									handlersRef.current?.increment()
								}
								variant="transparent"
								size="18px"
								c={'#9BA6B7'}
							>
								<IconChevronUp stroke={1.5} />
							</ActionIcon>
							<ActionIcon
								onClick={() =>
									handlersRef.current?.decrement()
								}
								variant="transparent"
								size="18px"
								c={'#9BA6B7'}
							>
								<IconChevronDown stroke={1.5} />
							</ActionIcon>
						</Stack>
					</Flex>
				) : undefined
			}
			{...rest}
		/>
	);
};
